export enum ClientPurchaseOrderStatus {
  Draft = 0,
  Submitted = 1,
  Approved = 2,
  InProduction = 3,
  PartiallyDispatched = 4,
  Dispatched = 5,
  Cancelled = 98,
  Deleted = 99,
}

export interface ClientPurchaseOrderItem {
  id: string;
  itemCode: string;
  productRecipeNumber?: string;
  uom: number;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  taxRate: number;
}

export interface ClientPurchaseOrder {
  id: string;
  number: string;
  status: number;
  type: number;
  clientReference: string;
  brandReference?: string;
  paymentTermCode: string;
  shipToReference: string;
  shipToAddressCode: number;
  billToReference: string;
  billToAddressCode: number;
  issuedDate: string;
  requestedDeliveryDate?: string;
  items: ClientPurchaseOrderItem[];
}

export interface ClientPurchaseOrderSearchCommand {
  number?: string;
  clientReference?: string;
  status?: number[];
  type?: number;
}
